// Wrapper for all backend requests. On the public (HTTPS) deployment every request
// goes to nate-vpn-proxy, which authenticates via the HttpOnly session cookie — so we
// send credentials. Over the VPN (http) the app talks to in-VPN services directly and
// must NOT send credentials (their permissive/wildcard CORS would reject a credentialed
// request), so we leave the default. A 401 means the session expired → notify the auth
// store via an event (avoids an auth/vpn store import cycle) so it shows the sign-in view.

export const UNAUTHORIZED_EVENT = 'nate:unauthorized';

function isPublicDeployment() {
  return typeof window !== 'undefined' && window.location.protocol === 'https:';
}

export default async function nateFetch(url, options = {}) {
  const isPublic = isPublicDeployment();

  const response = await fetch(url, {
    ...options,
    credentials: isPublic ? 'include' : (options.credentials ?? 'same-origin'),
  });

  if (isPublic && response.status === 401) {
    window.dispatchEvent(new CustomEvent(UNAUTHORIZED_EVENT));
  }

  return response;
}
